import jwtDecode from 'jwt-decode';
import { ITokenData } from './types';

export default function generateTokenData(tokenData: ITokenData | undefined) {
  if (!tokenData) {
    return;
  }

  let email;
  let username;

  if (tokenData.idToken) {
    ({ email, 'cognito:username': username } = jwtDecode(tokenData.idToken));
  }

  return {
    ...tokenData,
    email,
    username,
    expiresAt: new Date().getTime() + tokenData.expiresAt * 1000,
  };
}
